import { ModelResource } from './resource';
import { DeductionCreditMemoLineItem } from '../models';

export class DeductionsCreditMemoLineItems extends ModelResource<DeductionCreditMemoLineItem> {
  model = DeductionCreditMemoLineItem;

  resourcePath = 'v1/deductions/credit-memo-line-items';

  async update(id: string, data, creditMemoLineItem?: DeductionCreditMemoLineItem) {
    const response = await this.api.patch(this.path(id), {
      data,
    });

    if (creditMemoLineItem) {
      creditMemoLineItem.updateFromJson(response.data);
    } else {
      creditMemoLineItem = DeductionCreditMemoLineItem.fromJson(response.data);
    }

    return creditMemoLineItem;
  }
}
